export default "__VITE_PUBLIC_ASSET__3edfd3ce__"